  let questionsrs = document.querySelectorAll(".questionsrs");
  questionsrs.forEach(questionsrs => {
    questionsrs.addEventListener("click", event => {
      const active = document.querySelector(".questionsrs.active");
      if (active && active !== questionsrs) {
        active.classList.toggle("active");
        active.nextElementSibling.style.maxHeight = 0;
      }
      questionsrs.classList.toggle("active");
      const answersrs = questionsrs.nextElementSibling;
      if (questionsrs.classList.contains("active")) {
        answersrs.style.maxHeight = answersrs.scrollHeight + "px";
      } else {
        answersrs.style.maxHeight = 0;
      }
    })
  })
